export default __webpack_public_path__ + "static/media/precise-location-unselected.bea69386.svg";